import { render, staticRenderFns } from "./SubPavilionButton.vue?vue&type=template&id=3672789a&scoped=true"
import script from "./SubPavilionButton.vue?vue&type=script&lang=js"
export * from "./SubPavilionButton.vue?vue&type=script&lang=js"
import style0 from "./SubPavilionButton.vue?vue&type=style&index=0&id=3672789a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672789a",
  null
  
)

export default component.exports